import { Droppable } from '@hello-pangea/dnd';
import { Box, Stack, Typography } from '@mui/material';

import { MissionLight, MissionStatus } from '@wwf/sdk';
import { MissionCard } from './MissionCard';
import { MissionStatusChip } from '../chips/MissionStatusChip';

export const MissionColumn = ({
    status,
    missionList,
}: {
    status: MissionStatus;
    missionList: MissionLight[];
}) => {
    const totalAmount = missionList.length;

    return (
        <Box
            sx={{
                flex: 1,
                paddingTop: '8px',
                paddingBottom: '16px',
                '&:first-of-type': {
                    borderTopLeftRadius: 5,
                },
                '&:last-of-type': {
                    borderTopRightRadius: 5,
                },
            }}
        >
            <Stack alignItems="center">
                <MissionStatusChip status={status} />
                <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    fontSize="small"
                >
                    {totalAmount}
                </Typography>
            </Stack>
            <Droppable droppableId={status}>
                {(droppableProvided, snapshot) => (
                    <Box
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                        className={
                            snapshot.isDraggingOver ? ' isDraggingOver' : ''
                        }
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 1,
                            padding: '5px',
                            '&.isDraggingOver': {
                                bgcolor: '#dadadf',
                            },
                        }}
                    >
                        {missionList.map((mission, index) => (
                            <MissionCard
                                key={mission.id}
                                mission={mission}
                                index={index}
                            />
                        ))}
                        {droppableProvided.placeholder}
                    </Box>
                )}
            </Droppable>
        </Box>
    );
};
